import { I18n } from "../services/I18n";
import "./generated/site-translations-it";
import common_it from "../../../../../libs/ps/restaumatic-common/locales/it.json";
import core_types_sites_it from "../../../../../libs/ps/restaumatic-core-types-sites/locales/it.json";
I18n.translations = I18n.translations || {};
I18n.translations = I18n.extend(I18n.translations, {
  it: { _core_types_sites: core_types_sites_it },
});
I18n.translations = I18n.extend(I18n.translations, {
  it: { _common: common_it },
});
